import { Box, SegmentGroup, SegmentGroupRootProps } from '@chakra-ui/react'

// The recipe sizes items in em of their own text, so `xs` (12px text) comes out 18px: shorter than
// a text line, and it no longer fills its track. 24px is the height the `xs` size intends.
const ITEM_HEIGHT: Partial<Record<'xs' | 'sm' | 'md' | 'lg', string>> = { xs: '24px' }

export const Segmented = ({
  options,
  value,
  onChange,
  palette = 'orange',
  size,
  containerProps,
}: {
  options: string[]
  value: string
  onChange: (v: string) => void
  palette?: string
  size?: 'xs' | 'sm' | 'md' | 'lg'
  containerProps?: SegmentGroupRootProps
}) => (
  // Flex, not block: the root is inline-flex and would otherwise sit on a text line, with extra
  // space under it.
  <Box bgColor={'colorPalette.container'} borderRadius={'md'} display={'flex'} padding={1}>
    <SegmentGroup.Root
      colorPalette={palette}
      size={size}
      value={value}
      width={'full'}
      onValueChange={e => onChange(e.value ?? '')}
      {...containerProps}
    >
      <SegmentGroup.Indicator />
      <SegmentGroup.Items
        flex={'1'}
        height={size ? ITEM_HEIGHT[size] : undefined}
        items={options}
        justifyContent={'center'}
      />
    </SegmentGroup.Root>
  </Box>
)
